import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { environment } from '@/environments/environment';
import { BriefsListRequest, BriefsListResponse } from './briefs-list.types';

const CACHE_MS = 15000;
const CACHE_LIMIT = 20;

@Injectable({ providedIn: 'root' })
export class BriefsListService {
  private readonly http = inject(HttpClient);
  private readonly cache = new Map<string, { at: number; value: BriefsListResponse }>();

  list(request: BriefsListRequest): Observable<BriefsListResponse> {
    const key = JSON.stringify(request);
    const hit = this.cache.get(key);
    if (hit && Date.now() - hit.at < CACHE_MS) {
      return of(hit.value);
    }
    return this.http
      .post<BriefsListResponse>(`${environment.shout_api.url}/briefs/studio-list`, request)
      .pipe(tap((value) => this.remember(key, value)));
  }

  forget(): void {
    this.cache.clear();
  }

  private remember(key: string, value: BriefsListResponse): void {
    this.cache.set(key, { at: Date.now(), value });
    if (this.cache.size <= CACHE_LIMIT) {
      return;
    }
    const oldest = this.cache.keys().next().value;
    if (oldest) {
      this.cache.delete(oldest);
    }
  }
}
